var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.id,class:_vm.setClass(),style:(_vm.styleSize)},[_c('div',{class:_vm.setClass('panel'),style:(_vm.styleDatetime)},[_vm._v("\n    "+_vm._s(_vm.nowDate)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }